import React from "react";
import {HSPCDataLoader} from "../loaders/HSPCDataLoader";
import {ConnectToURLWithQualityPage} from "./ConnectToURLWithQualityPage";

interface Props {
  onPrevious: () => void;
  onReset: () => void;
}

export const ConnectToHSPCWizard = ({onPrevious, onReset}: Props) => {
  return (
      <ConnectToURLWithQualityPage
          defaultURL="https://datamonster.myvr.net/mMap/data/pointcloud/APR/SanFrancisco/tree.hspc"
          onCreateLayer={HSPCDataLoader.createLayer}
          onPrevious={onPrevious}
          onReset={onReset}
      />
  )
}